/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "从右到左",
		"timeZoneID": "时区",
		"skin": "样式",
		"metricsFileImportTask": "从文件新建导入",
		"displayMode": "默认视图",
		"credentialRenewed": "已使用您的当前用户标识和密码更新您的凭证。",
		"productLocale": "产品语言",
		"toggleDisabled": "关闭",
		"credentialChange": "更新",
		"log_level_Debug": "调试",
		"confirmNewPassword": "确认新密码",
		"unsavedViewMsg2": "如果未先保存更改，这些更改都将丢失。",
		"supportPortalErrorMessage": "请重试。如果问题仍然存在，请联系管理员。",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM、IBM 徽标、ibm.com 和 Cognos 是 International Business Machines Corp. 在全球许多管辖区域注册的商标或注册商标。当前的 IBM 商标列表，可从 Web 站点 www.ibm.com/legal/copytrade.shtml 中获取。本程序依据本程序随附许可协议的条款许可使用。本许可协议可能位于一个名为“License”或“Non_IBM_License”的程序目录文件夹或库中（如果适用），或可作为打印的许可协议提供。在使用本程序之前，请仔细阅读本协议。使用本程序即表明您同意这些条款。",
		"groupsAndRoles": "组和角色",
		"metricsMaintenanceTask": "新建维护",
		"email": "电子邮件",
		"contextual": "上下文",
		"resetHome": "重置为默认值",
		"ltr": "从左到右",
		"credentials": "凭证",
		"logging_congfig_title": "日志记录",
		"changePasswordTitle": "更改我的密码",
		"format": "报表格式",
		"showUnread": "显示未读",
		"AILearning_active": "AI 学习时间：",
		"docsErrorMessage": "请重试。如果问题仍然存在，请联系管理员。",
		"toggleEnabled": "打开",
		"homeSetError": "设置默认主页时发生错误，请尝试关闭并重新打开此视图。",
		"passwordChange": "更改密码",
		"profile": "概要文件",
		"pdfRestricted": "PDF（受限）",
		"drillThrough": "穿透钻取定义",
		"homeSet": "您的主目录已成功设置",
		"regionalOptions": "区域选项",
		"myPreferences": "我的首选项",
		"defaultHome": "默认",
		"version": "版本",
		"controller": "Controller",
		"manage": "管理",
		"biDirectionalFeaturesEnabled": "双向语言支持",
		"newFeaturesErrorTitle": "“新增功能”的链接无效",
		"passwordMatch": "密码匹配",
		"updateProfileAndsettings": "更新概要文件和设置",
		"dashboardConsole": "工作空间",
		"legacyAppsSlideoutLabel": "可用旧应用程序",
		"logging_config_description": "日志记录用于故障诊断。请咨询管理员以获取有关设置的指导。",
		"confirmDeletion": "确认删除",
		"signInButtonText": "登录",
		"dataSourceCredentials": "数据服务器凭证",
		"AILearningConfigurationSlideoutAllyLabel": "AI 学习配置",
		"loadingSettings": "正在装入设置",
		"spreadsheetMLRestricted": "Excel（受限）",
		"manageAILearning": "AI 学习",
		"xlsxDataRestricted": "Excel 数据（受限）",
		"advanced": "高级选项",
		"ok": "确定",
		"changeEmail": "更改",
		"showHints": "显示提示",
		"general": "常规",
		"xlsxData": "Excel 数据",
		"newPassword": "新密码",
		"hideAll": "全部隐藏",
		"confirmPassword": "确认密码",
		"AILearning_config_description": "通过允许 Cognos Analytics 了解您的使用情况，改进产品内的建议。",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "“支持门户网站”的链接无效",
		"log_level_Warn": "警告",
		"contentSettings": "内容设置",
		"setHomeButton": "设置",
		"myCapabilities": "我的能力",
		"homePage": "主页",
		"helpErrorMessage": "请重试。如果问题仍然存在，请联系管理员。",
		"loadingProfile": "正在装入概要文件",
		"portal": "门户网站",
		"metricsPackage": "新建数据包",
		"myCredentials": "我的凭证",
		"credentialCreate": "创建",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "无法更新密码",
		"showHiddenObjects": "显示隐藏的条目",
		"csv": "CSV",
		"docsErrorTitle": "“文档”的链接无效",
		"log_level_Error": "错误",
		"wrongPassword": "无法认证",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "信息",
		"welcomeBanner": "欢迎条幅",
		"helpErrorTitle": "“帮助”的链接无效",
		"contentLocale": "内容语言",
		"pdf": "PDF",
		"oldPassword": "旧密码",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "辅助功能选项功能",
		"manageLogging": "日志记录",
		"loggingConfigurationSlideoutA11yLabel": "日志记录配置",
		"communityErrorTitle": "“社区”的链接无效",
		"companionApps": "伙伴应用程序",
		"setHomeLabel": "将主页设置为（当前视图）",
		"metricsExportTask": "新建导出",
		"csvRestricted": "CSV（受限）",
		"newFeaturesErrorMessage": "请重试。如果问题仍然存在，请联系管理员。",
		"contributor": "Contributor",
		"showAll": "全部显示",
		"logging_active": "日志记录时间：",
		"html": "HTML",
		"profileAndSettings": "概要文件和设置",
		"baseTextDirection": "文本的基本方向",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "密码",
		"invalidEmail": "输入有效的电子邮件地址",
		"credentialCreateSuccess": "您已成功创建凭证",
		"settings": "设置",
		"restrictedFormatSelected": "您无权运行此格式的报表，但可以访问以此格式保存的报表。",
		"usageDataDeletionConfirmation": "删除使用情况数据将重置所有 AI 学习。确定要删除使用情况数据吗？",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "查看详细信息",
		"deleteUsageData": "删除使用情况数据：",
		"showPassword": "显示密码",
		"AILearning_config_title": "AI 学习",
		"myPreferencesSlideoutLabel": "概要文件和设置",
		"passWordChangeSuccess": "您已成功更改密码",
		"logging_level": "日志记录级别：",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "请重试。如果问题仍然存在，请联系管理员。",
		"cancel": "取消",
		"shareSetError": "关闭并重新打开此视图后，才能执行此操作。",
		"passwordNotMatch": "密码不匹配",
		"xml": "XML",
		"xmlRestricted": "XML（受限）",
		"openMenu": "打开菜单",
		"closeMenu": '关闭菜单'
});